const properties = {
  strokeWidth: 1,
  fillColour: '#B8B8B8',
  strokeColour: 'black',
}

type PropTypes = {
  height: number,
  width: number,
  xOffset?: number,
  yOffset?: number,
}

const Slab = ({ height, width, xOffset = 0, yOffset = 0 }: PropTypes) => {
  return (
    <rect
      x={xOffset}
      y={yOffset}
      width={width}
      height={height}
      stroke={properties.strokeColour}
      fill={properties.fillColour}
      strokeWidth={properties.strokeWidth}
    />
  )
}

export default Slab
